import { Button, Grid } from "@mui/material";
import React, { useEffect } from "react";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { IScheduleEvent } from "../../redux/reducers/schedule.reducer";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import TimerOffOutlinedIcon from "@mui/icons-material/TimerOffOutlined";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import { useSelector } from "react-redux";
import { storeStateType, useAppDispatch } from "../../redux/store";
import ApartmentIcon from "@mui/icons-material/Apartment";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import NotesIcon from "@mui/icons-material/Notes";
import FormatQuoteOutlinedIcon from "@mui/icons-material/FormatQuoteOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import { worktypeOptionType } from "./ScheduleHeader";
import Modal from "@mui/material/Modal";
import { loadSingleEvent } from "../../redux/actions/schedule.actions";
import { LOAD_LATEST_SELECTED_EVENT_DATA } from "../../redux/types/schedule.types";
import Loading from "react-loading";
import { eventForm } from "../CalendarForms/Types/calendarTypes";
import ModalBoxHeader from "../../components/ModalBoxHeader";

// const Modal = ({ children, onClose, title, className }: modalPropsType) => {
//   return (
//     <>
//       <div className="overlay" onClick={onClose} />
//
//     </>
//   );
// };

type propsType = {
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowingEventForm: React.Dispatch<React.SetStateAction<eventForm>>;
  setSelectedEvent: React.Dispatch<React.SetStateAction<IScheduleEvent | null>>;
  setShowAssignEmployeeModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleDeleteEvent: Function;
  selectedEvent: IScheduleEvent | null;
  titleName: string;
};
export default function EditMenuModal(props: propsType) {
  const {
    setShowEditModal,
    setShowingEventForm,
    setSelectedEvent,
    setShowAssignEmployeeModal,
    handleDeleteEvent,
    selectedEvent,
    titleName,
  } = props;

  const dispatch = useAppDispatch();
  const { themeMode } = useSelector((state: storeStateType) => state.UI);

  const { facilities, latestSelectedEventData } = useSelector(
    (state: storeStateType) => state.schedule
  );

  const { work_types: workTypes, loading } = useSelector(
    (state: storeStateType) => state.schedule
  );

  function handleEditClick() {
    setShowingEventForm((preState: eventForm) => {
      return { ...preState, visible: true };
    });
    setShowEditModal(false);
  }
  function handleDeleteClick() {
    handleDeleteEvent();
  }

  function handleModalClose() {
    setShowEditModal(false);
    setSelectedEvent(null);
    dispatch({ type: LOAD_LATEST_SELECTED_EVENT_DATA, payload: null });
  }

  useEffect(() => {
    dispatch(loadSingleEvent(selectedEvent?.id ?? ""));
  }, [dispatch, selectedEvent]);

  function handleAssignEmployee(e: any) {
    // let currentDate = new Date();
    // let scheduleDate = new Date(selectedEvent.end_time);
    // if (currentDate <= scheduleDate) {
    setShowEditModal(false);
    setShowAssignEmployeeModal(true);
    // }
    e.stopPropagation();
  }

  /**
   *
   * @param arr :array of facilities objects with neested child catagories
   * @returns arr :flattened array of facilities
   */
  function flattenArray(arr: any) {
    const result: any[] = [];
    arr.forEach((obj: any) => {
      result.push(obj);
      if (obj.childCategories.length > 0) {
        result.push(...flattenArray(obj.childCategories));
      }
    });
    return result;
  }

  let flattenedFacilitiesList = flattenArray(facilities);
  let selectedFacility = "";
  let selectedSubFacility = "";
  let selectedWorkType = "";

  flattenedFacilitiesList.forEach((facility) => {
    if (facility.id === latestSelectedEventData?.facility) {
      selectedFacility = facility.facility_name;
    }
    if (facility.id === latestSelectedEventData?.sub_facility) {
      selectedSubFacility = facility.facility_name;
    }
  });

  workTypes.forEach((worktype: worktypeOptionType) => {
    if (worktype.id === latestSelectedEventData?.work_type) {
      selectedWorkType = worktype.name;
    }
  });

  const date = new Date(latestSelectedEventData?.schedule_date ?? "");
  const dateString = date.toLocaleString("en-AU", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

  return (
    <Modal
      open={true}
      className=""
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className="rostme-modal"
        position="relative"
        sx={{ backgroundColor: "background.paper" }}
      >
        <ModalBoxHeader title={titleName} handleClose={handleModalClose} />

        {!latestSelectedEventData && (
          <Box
            aria-label="loading-container"
            height="80vh"
            display="flex"
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Loading
              type="bars"
              width="70px"
              height="70px"
              color={themeMode === "dark" ? "#fcfcfc" : "#000000"}
            />
          </Box>
        )}
        {latestSelectedEventData && (
          <>
            <Box
              className="modal-body"
              sx={{
                padding: "0.4rem",
                height: "80vh",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
            >
              <Box display="flex" justifyContent="flex-end">
                <Button
                  onClick={handleEditClick}
                  sx={{ color: "primary.main" }}
                >
                  Edit
                  <DriveFileRenameOutlineIcon />
                </Button>

                <Button
                  onClick={handleDeleteClick}
                  color="error"
                  disabled={loading}
                >
                  Delete
                  <DeleteOutlineIcon />
                </Button>
              </Box>
              <Box
                className="schedule-date"
                display={"flex"}
                alignItems="center"
                justifyContent="center"
              >
                <Box margin="1rem 0">
                  <CalendarMonthOutlinedIcon />
                  <Typography variant="subtitle1">
                    {latestSelectedEventData?.schedule_date}
                  </Typography>
                  <Typography variant="subtitle1">{`${dateString}`}</Typography>
                </Box>
              </Box>
              <Grid container margin={"1rem"}>
                <Box
                  flex={1}
                  display="flex"
                  onClick={(e) => handleAssignEmployee(e)}
                >
                  {latestSelectedEventData?.assigned_to ? (
                    <>
                      <IconButton
                        key={latestSelectedEventData?.assigned_to.id}
                        sx={{ p: 0, marginRight: 1 }}
                      >
                        <Avatar
                          title={`${latestSelectedEventData?.assigned_to?.fullname}`}
                          sx={{
                            height: "20px",
                            width: "20px",
                            fontSize: "10px",
                            bgcolor: "primary.main",
                            marginRight: "0.6rem",
                          }}
                          alt={`${latestSelectedEventData?.assigned_to?.fullname}`}
                          src={
                            latestSelectedEventData?.assigned_to.avatar ??
                            "null"
                          }
                        />
                      </IconButton>
                      <Typography variant="subtitle1" fontWeight={500}>
                        {`${latestSelectedEventData?.assigned_to?.fullname} `}
                      </Typography>
                    </>
                  ) : (
                    <>
                      <IconButton key={"add"} sx={{ p: 0, marginRight: 1 }}>
                        <Avatar
                          sx={{ height: "20px", width: "20px" }}
                          alt={"+"}
                          src={"null"}
                        />
                      </IconButton>
                      <Typography
                        variant="subtitle1"
                        sx={{ marginLeft: "0.6rem" }}
                      >
                        Assign employee
                      </Typography>
                    </>
                  )}
                </Box>
              </Grid>
              <Grid container>
                <Grid container>
                  <Grid item xs={2}>
                    <ApartmentIcon className="schedule-info-icon" />
                  </Grid>
                  <Grid item xs={10}>
                    <Typography
                      className="schedule-facility"
                      variant="subtitle1"
                      textAlign="start"
                      fontWeight={600}
                      gap="0.6rem"
                    >
                      {selectedFacility}
                    </Typography>
                  </Grid>
                </Grid>
                {selectedSubFacility && (
                  <Grid container>
                    <Grid item xs={2}>
                      <LocationCityIcon className="schedule-info-icon" />
                    </Grid>
                    <Grid item xs={10}>
                      <Typography
                        className="schedule-subfacility"
                        variant="subtitle1"
                        textAlign="start"
                        gap="0.6rem"
                      >
                        {selectedSubFacility}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
                <Grid container>
                  <Grid item xs={2}>
                    <TimerOutlinedIcon className="schedule-info-icon" />
                  </Grid>
                  <Grid item xs={10}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={500}
                      textAlign={"start"}
                    >
                      {latestSelectedEventData?.start_time.slice(11, 19)}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={2}>
                    <TimerOffOutlinedIcon className="schedule-info-icon" />
                  </Grid>
                  <Grid item xs={10}>
                    <Typography
                      fontWeight={500}
                      variant="subtitle2"
                      textAlign={"left"}
                    >
                      {latestSelectedEventData?.end_time.slice(11, 19)}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={2}>
                    <FormatQuoteOutlinedIcon className="schedule-info-icon" />
                  </Grid>
                  <Grid item xs={10}>
                    <Box display="flex" justifyContent={"flex-start"}>
                      {latestSelectedEventData?.schedule_status === 0 && (
                        <Typography variant="subtitle1">Closed</Typography>
                      )}
                      {latestSelectedEventData?.schedule_status === 1 && (
                        <Typography variant="subtitle1">Opened</Typography>
                      )}
                      {latestSelectedEventData?.schedule_status === 2 && (
                        <Typography variant="subtitle1">Assigned</Typography>
                      )}
                      {latestSelectedEventData?.schedule_status === 3 && (
                        <Typography variant="subtitle1">Unfulfilled</Typography>
                      )}
                      {latestSelectedEventData?.schedule_status === 4 && (
                        <Typography variant="subtitle1">Fulfilled</Typography>
                      )}
                      {latestSelectedEventData?.schedule_status === 5 && (
                        <Typography variant="subtitle1">Assigned</Typography>
                      )}
                    </Box>{" "}
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={2}>
                    <WorkOutlineOutlinedIcon className="schedule-info-icon" />
                  </Grid>
                  <Grid item xs={10}>
                    <Typography
                      variant="subtitle1"
                      textAlign="start"
                      display="flex"
                      alignItems="center"
                      gap="0.6rem"
                    >
                      {selectedWorkType}
                    </Typography>
                  </Grid>
                </Grid>
                {latestSelectedEventData?.schedule_note && (
                  <Grid container>
                    <Grid item xs={2}>
                      <NotesIcon className="schedule-info-icon" />
                    </Grid>
                    <Grid item xs={10}>
                      <Typography
                        className="schedule-facility"
                        variant="subtitle1"
                        fontStyle="italic"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.6rem",
                        }}
                      >
                        {latestSelectedEventData?.schedule_note}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Box>
          </>
        )}
      </Box>
    </Modal>

    // <Modal open={true} className="" onClose={handleModalClose} title={`Schedule Info`}>

    // </Modal>
  );
}
